export default __webpack_public_path__ + "static/media/worrying.40aadcf6.jpg";